import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import { productIcon } from '../helpers'
import React from 'react'

const SamplingsProduct = props => {
  // console.log(props.data)
  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      container
      alignItems="center"
      className={props.classes.product}
      onClick={() => {
        if (props.data && props.data.samplings.length) {
          props.onSelectSamplingProduct(props.data.productType)
        }
      }}>
      <Grid item xs={4} align="center">
        <img alt="" src={productIcon(props.data.productIconFileName)} className={props.classes.productIcon} />
      </Grid>
      <Grid item xs={7}>
        <div>
          <div>
            <Typography className={props.classes.productName}>{props.data.productType}</Typography>
          </div>
          <div>
            <Grid container>
              <Grid item xs={6}>
                <Typography>Clasificado</Typography>
                <Typography className={props.classes.productSampledValue}>
                  {props.data.kgSampledTotal.toLocaleString(undefined, { maximumFractionDigits: 2 })} kg.
                </Typography>
                <Typography className={props.classes.productSampledValue} style={{ marginTop: -4 }}>
                  {props.data.eurosSampledTotal.toLocaleString(undefined, { maximumFractionDigits: 2 })} €
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>Pendiente</Typography>
                <Typography className={props.classes.productSampledValue}>
                  {props.data.kgPendingTotal.toLocaleString(undefined, { maximumFractionDigits: 2 })} kg.
                </Typography>
              </Grid>
            </Grid>
          </div>
          {props.data.averagePrice > 0 && (
            <div style={{ marginTop: 4 }}>
              <span>
                <Typography className={props.classes.productAveragePrice}>
                  <span className={props.classes.averagePrice}>
                    {props.data.averagePrice.toLocaleString(undefined, { maximumFractionDigits: 2 })} €
                  </span>
                  <span style={{ marginLeft: 5 }}>precio medio</span>
                </Typography>
              </span>
            </div>
          )}
        </div>
      </Grid>
      <Grid item xs={1}>
        {props.data && props.data.samplings.length && <KeyboardArrowRightIcon />}
      </Grid>
    </Grid>
  )
}

const styles = {
  product: {
    padding: '5px 0',
    borderRight: '1px solid #BBB',
    borderBottom: '1px solid #BBB',
    cursor: 'pointer',
  },
  productIcon: {
    width: '80%',
    maxWidth: 120,
  },
  productName: {
    fontSize: 16,
    fontWeight: 500,
    color: '#1B458E',
  },
  productSampledValue: {
    fontSize: 16,
    fontWeight: 600,
  },
  productAveragePrice: {
    display: 'inline-block',
    background: '#8ACA4C',
    borderRadius: 5,
    color: 'white',
    padding: '3px 5px',
    fontSize: 16,
  },
  averagePrice: {
    background: 'white',
    borderRadius: 5,
    color: '#000',
    padding: '2px 7px',
    fontSize: 15,
    fontWeight: 600,
  },
}

export default withStyles(styles)(SamplingsProduct)



// WEBPACK FOOTER //
// ./src/components/SamplingsProduct.js